module.exports = __webpack_public_path__ + "static/media/nc.5abc98ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/nc.svg
// module id = 206
// module chunks = 0